import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import enJson from "./assets/i18n/en.json";
// import zhJson from "./assets/i18n/zh.json";

i18n.use(initReactI18next).init({
  resources: {
    // en: { ...enJson },
    // zh: { ...zhJson },
  }, // Where we're gonna put translations' files
  lng: 'en', // Set the initial language of the App
});
